import {useData} from "vike-react/useData";
import {ApiProfileUserData, ApiVideo} from "#/src/definitions/ApiDefinitions";
import {usePageContext} from "vike-react/usePageContext";
import {Sort} from "#/src/utils/sort-utils";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import {getProfileUrl} from "#/src/utils/profile-url";
import eye from "#/src/assets/svg/eye.svg";
import {DataWrapped} from "#/src/definitions/AppDefinitions";
import {AvatarWithFallback} from "#/src/components/AvatarWithFallback";
import React from "react";

export function VideosPeek() {
  const {data: profileData} = useData() as DataWrapped<ApiProfileUserData>;
  const {urlPathname} = usePageContext();

  function render() {
    return <div className="video-wrapper">
      <div className="title-between flex-wrap mt-0 mb-4">
        <div className="d-flex align-items-center gap-3">
          <h2 className="basic-headline basic-headline-sm">
            Dodane filmy
          </h2>
        </div>
        {urlPathname.startsWith("/my-profile") && <a href={"/my-profile/videos"} className="more-link">
          Pokaż więcej
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 15L12.5 10L7.5 5" stroke="#EEF5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>}
      </div>
      {renderVideos()}
    </div>
  }

  function renderVideos() {
    const sorted = Sort.byDate(profileData.user.videosPeek);
    return sorted.map((video: ApiVideo) => {
      function getThumbnailUrl() {
        if (video.thumbnailUrl == null) {
          return Attachments.getUrl(AttachmentNamespace.VIDEO, video);
        }
        return video.thumbnailUrl;
      }

      return <div className="post-flex">
        <div className="post-wrapper">
          <figure className="post-img">
            <img src={getThumbnailUrl()} alt={video.title}/>
          </figure>
          <div className="post-content">
            <a href={video.url} className="article-link">{video.title}</a>
            <div className="article-author mt-2">
              <div className="author">
                <AvatarWithFallback user={video.author} className={"avatar avatar-20"}/>
                <a href={getProfileUrl(video.author)} className="author-link">{video.author.username}</a>
              </div>
              <div className="article-date">
                <img src={eye} alt={"Odsłon"} className={"me-1"}/>
                <span>{video.views} odsłon</span>
                {video.pendingModeration && <span className={"ms-2 text-primary"}>W moderacji</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    });
  }

  return render();
}